"use strict";

define('adapter/param',['underscore', 'backbone'], function (_, Backbone) {
  function Adapter(model, options) {
    if (model instanceof Backbone.Model) {
      this.model = model;
    } else {
      this.model = new Backbone.Model(model);
    }
    this.options = _.extend({}, _.result(this, 'options'), options);
  }
  ;
  Adapter.extend = Backbone.View.extend;
  _.extend(Adapter.prototype, {
    serializeFilter: function serializeFilter() {
      return this.model.toJSON();
    },
    setup: function setup(collection) {
      if (this.options.autoFetch === true) {
        collection.once('request', function () {
          this.model.on('change', _.debounce(function () {
            collection.fetch();
          }, 1));
        }, this);
      }
    },
    preprocess: function preprocess(options) {
      var data = _.extend({}, this.serializeFilter(), options.data);
      _.each(data, function (value, key) {
        if (value != null) {
          data[key] = this.cleanValue(value);
        } else {
          data[key] = value;
        }
      }, this);
      options.data = data;
    },
    cleanValue: function cleanValue(value) {
      var finalValue = '';
      value = value == null ? '' : String(value);
      for (var i = 0, len = value.length, code; i < len; ++i) {
        code = value.charCodeAt(i);
        if (code == 160) {
          code = 32;
        }
        finalValue += String.fromCharCode(code);
      }
      return finalValue;
    }
  });
  return Adapter;
});

